<template>
  <div>
    <web-cam
      v-show="true"
      ref="webcam"
      width="100%"
      :deviceId="deviceId"
      @success="onSuccess"
      @error="onError"
      @cameras="onCameras"
      :isFrontCam="true"
      :debug="false"
    />
  </div>
</template>

<script>
import { WebCam } from 'vue-web-cam'
export default {
  components: {
    WebCam,
  },
  data () {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      frontCam: true
    }
  },
  computed: {
    device: function () {
      return find(this.devices, n => n.deviceId == this.deviceId);
    }
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      if (typeof window.orientation === 'undefined') {
        // Once we have a list select the first one
        let first = this.devices[0];
        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
        }
      } else {
        this.frontCam = false;
      }
    }
  },
  methods: {
    start() {
      var self = this;
      self.onCapture();
    },
    async onCapture () {
      this.img = await this.$refs.webcam.capture();

      var block = this.img.split(";");
      var contentType = block[0].split(":")[1];
      if(contentType != ","){
        var realData = block[1].split(",")[1];
        var blob = await this.b64toBlob(realData, contentType);
        this.uploadSnapshot(blob);
      }
    },
    onError (error) {},
    onSuccess () {
      this.$vs.dialog({
        color: 'success',
        title: 'Camera Accessed!',
        text: 'Great! Now you can start!',
        acceptText: "Thanks",
      })
    },
    reloadPage() {
      this.$router.go();
    },
    onCameras (cameras) {
      this.devices = cameras;
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = window.atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    uploadSnapshot(blob) {
      var self = this;
      var formData = new FormData();
      formData.append('image', blob, "student");

      var onSuccess = response => {};

      self.$ajaxPost(self, "Student/UploadSnapshot", formData, onSuccess);
    }
  },
  mounted() {
    
  }
}
</script>